export default __webpack_public_path__ + "static/media/location-icon.ef24f362.svg";